/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var $ = require('jquery');
var IIN = require('op-identify-card');
var switchForm = require('./switch.service');
var getNetworkByCode = require('./networks.service').getNetworkByCode;
var paymentLayout = require('../services/payment-option-layout.service');
var placeholderSwitch = require('./placeholder-switch.service');

/**
 * Test the code written in cardNumberField input field
 * and identify if it belongs to witch network inside networks list
 * make switch
 * @param {Object} rootScope contains method to share global variables between components
 * @param {JQueryElement} cardNumberField jquery selector for card number input field
 * @param {Object} networks
 */
function identifyCodeAndSwitch(rootScope, cardNumberField, networks) {
    var currentNetworkCode = rootScope.getSelectedNetworkCode();

    var code = IIN.identifyCode(cardNumberField.val());
    // only switch if the code is identified and that the wrong form is displayed for that card number
    if (code && getNetworkByCode(networks, code)) {
        if (code != currentNetworkCode) {
            //switch form elements and show icons for smart switch and networks chosen: display only 1 icon
            switchForm(code, rootScope);
        } else {
            // highlight icons and show labels for the found code when input field was empty
            paymentLayout.handleSmartSwitchForm(code, false);
        }
        placeholderSwitch.useSpecificPlaceholder(code);
    } else {
        //highlight all labels and show default label
        paymentLayout.handleSmartSwitchForm(null, false);
        placeholderSwitch.useGenericPlaceholder(currentNetworkCode);
    }
}

function bindSmartSwitch(networks, rootScope) {
    var groupType = 'CREDIT_CARD';

    var inputField = $('.formContainer' + groupType + ' .number');

    inputField.on('paste', function () {
        var element = $(this);
        window.setTimeout(function () {
            identifyCodeAndSwitch(rootScope, element, networks);
        }, 100);
    });
    inputField.on('keyup', function () {
        identifyCodeAndSwitch(rootScope, $(this), networks);
    });
}

module.exports = bindSmartSwitch;
